import { truncateSubtitle } from '@helpers/seoText';
import * as React from 'react';

interface UseSeoTextReturn {
  text: string | null | undefined;
  hasTruncated: boolean;
}

function useSeoText(text: string | null | undefined, wordLimit?: number): UseSeoTextReturn {
  const [truncatedText, setTruncatedText] = React.useState<string | null | undefined>(text);
  const [hasTruncated, setHasTruncated] = React.useState(false);

  React.useEffect(() => {
    if (text) {
      const subtitle = truncateSubtitle(text, wordLimit);
      setTruncatedText(subtitle || text);
      setHasTruncated(!!subtitle);
    } else {
      setTruncatedText(text);
      setHasTruncated(false);
    }
  }, [text, wordLimit]);

  return { text: truncatedText, hasTruncated };
}

export default useSeoText;
